import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { FORM_TYPE } from '@pyg-services/forms/forms.constants';
import { FormsService } from '@pyg-services/forms/forms.service';
import { FormTypeEnum } from '@pyg-services/forms/forms.types';

@Component({
  selector: 'app-popup-subscribe',
  templateUrl: './popup-subscribe.component.html',
  styleUrls: ['./popup-subscribe.component.scss'],
  imports: [TranslatePipe, ReactiveFormsModule, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: FORM_TYPE, useValue: FormTypeEnum.SUBSCRIBE },
    FormsService,
  ],
})
export class PopupSubscribeComponent {
  private readonly formService =
    inject<FormsService<FormTypeEnum.SUBSCRIBE>>(FormsService);

  public readonly subscribeStatus = this.formService.requestStatus;
  public readonly demoForm = this.formService.form;

  readonly place = input.required<string>();

  public sendEmail() {
    this.formService.submit(this.place());
  }

  public resetStatus() {
    this.formService.resetStatus();
  }
}
